<!--Navigation Bar-->
<app-navbar>
    <h2>{{"QUESTIONS.TITLE" | translate}}</h2>
</app-navbar>

<section class="faq-area pt-100">
    <div class="container">
        <div class="row faq-wrap mb-30">
            <div class="col-lg-12">
                <div class="faq-head">
                    <h3 class="custom-section-title">AgriBusinessJob</h3>
                </div>

                <div class="row">
                    <div class="col-12 wow fadeInUp" data-wow-delay=".3s">
                        <button class="btn faq-btn w-100 text-left my-4" type="button" data-toggle="collapse"
                                data-target="#question1" aria-expanded="false"
                                aria-controls="question1">
                                {{"QUESTIONS.Q1_TITLE" | translate}}
                        </button>

                        <div class="collapse multi-collapse" id="question1">
                            <div class="card card-body" [innerHTML]="'QUESTIONS.Q1_HTML' | translate"></div>
                        </div>
                    </div>

                    <div class="col-12 wow fadeInUp" data-wow-delay=".4s">
                        <button class="btn faq-btn w-100 text-left my-4" type="button" data-toggle="collapse"
                                data-target="#question2" aria-expanded="false"
                                aria-controls="question2">
                                {{"QUESTIONS.Q2_TITLE" | translate}}
                        </button>

                        <div class="collapse multi-collapse" id="question2">
                            <div class="card card-body" [innerHTML]="'QUESTIONS.Q2_HTML' | translate"></div>
                        </div>
                    </div>

                    <div class="col-12 wow fadeInUp" data-wow-delay=".5s">
                        <button class="btn faq-btn w-100 text-left my-4" type="button" data-toggle="collapse"
                                data-target="#question3" aria-expanded="false"
                                aria-controls="question3">
                                {{"QUESTIONS.Q3_TITLE" | translate}}
                        </button>

                        <div class="collapse multi-collapse" id="question3">
                            <div class="card card-body" [innerHTML]="'QUESTIONS.Q3_HTML' | translate"></div>
                        </div>
                    </div>

                    <div class="col-12 wow fadeInUp" data-wow-delay=".6s">
                        <button class="btn faq-btn w-100 text-left my-4" type="button" data-toggle="collapse"
                                data-target="#question4" aria-expanded="false"
                                aria-controls="question4">
                                {{"QUESTIONS.Q4_TITLE" | translate}}
                        </button>

                        <div class="collapse multi-collapse" id="question4">
                            <div class="card card-body" [innerHTML]="'QUESTIONS.Q4_HTML' | translate"></div>
                        </div>
                    </div>

                    <div class="col-12 wow fadeInUp" data-wow-delay=".7s">
                        <button class="btn faq-btn w-100 text-left my-4" type="button" data-toggle="collapse"
                                data-target="#question5" aria-expanded="false"
                                aria-controls="question5">
                                {{"QUESTIONS.Q5_TITLE" | translate}}
                        </button>

                        <div class="collapse multi-collapse" id="question5">
                            <div class="card card-body" [innerHTML]="'QUESTIONS.Q5_HTML' | translate"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!--Footer-->
<app-footer></app-footer>